import { Dropdown, Spin } from 'antd'
import Flex from 'components/Flex'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { CustomExportButton } from '../../modules/JobRoles/PageHeader/style'

let randomString = Math.random().toString(36).substring(2, 7)
export const FilterFlex = styled.div`
  width: max-content;
`
export const FilterText = styled.p`
  margin-bottom: 0;
  margin-left: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const StyledDropdown = styled(Dropdown)`
  cursor: pointer;

  padding-left: 10px;
`

export const FlexWrap = styled(Flex)`
  position: relative;
`

const FilterDiv = ({
  overlayMenu,
  label = 'Filter',
  trigger = 'click',
  open = false,
  setOpen,
  id = randomString,
  onOpenChange,
  exportLoading,
  buttonDisabled,
  isViewDriveReport = false
}) => {
  const visibleChange = flag => {
    setOpen(flag)
  }

  return (
    <FlexWrap id={id}>
      <StyledDropdown
        overlay={overlayMenu}
        trigger={[trigger]}
        open={open}
        onVisibleChange={visibleChange}
        getPopupContainer={trigger => trigger.parentNode}
      >
        <FilterFlex centerVertically onClick={e => onOpenChange(e)}>
          <CustomExportButton
            text={label}
            // label={label}
            isViewDriveReport={isViewDriveReport}
            disabled={exportLoading || buttonDisabled}
            icon={
              exportLoading ? (
                <Spin
                  tip="Loading"
                  size="small"
                  style={{ display: 'flex', alignItems: 'center' }}
                />
              ) : (
                <></>
              )
            }
          />
        </FilterFlex>
      </StyledDropdown>
    </FlexWrap>
  )
}

export default FilterDiv
